import { CountriesService_countryServiceGetCountryNames } from '@festina/legalentity-general-types/legalentity/hooks/CountriesService_countryServiceGetCountryNames'

export const useFetchCountryNames =
  CountriesService_countryServiceGetCountryNames.useSuspenseQuery
